export const headers = [
    'Caja registradora',
    'Fecha de cierre',
    'Diferencia',
    'Usuario'
];
export const keyColumns = [
    'cashRegisterName',
    'closing',
    'diff',
    'userEmail'
];

export const columns = [
    {
        field: 'cashRegisterName',
        header: 'Caja registradora',
        sizes: { xs: 3 }
    },
    {
        field: 'closing',
        header: 'Fecha de cierre',
        type: 'date24',
        sizes: { xs: 2 }
    },
    {
        field: 'diff',
        header: 'Diferencia',
        sizes: { xs: 2 }
    },
    {
        field: 'userEmail',
        header: 'DUsuario',
        sizes: { xs: 4 }
    },
];

export const title = "Cierre de Caja";
